export default "__VITE_ASSET__nMJ4gDLi__"